import { NotifyHelper } from "../../../helpers/toast";
import { eGiangVienActionsObj } from "../../action-types/category/IGiangVienActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const giangVienActions = {
  ...generateActions(eGiangVienActionsObj, "GIANG_VIEN"),
  ...generateActionForKey(
    eGiangVienActionsObj,
    "GIANG_VIEN",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eGiangVienActionsObj,
    "GIANG_VIEN",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eGiangVienActionsObj,
    "GIANG_VIEN",
    "SAVE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eGiangVienActionsObj,
    "GIANG_VIEN",
    "DELETE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
